import { render, staticRenderFns } from "./packageDetails.pug?vue&type=template&id=32a92275&lang=pug&"
import script from "./packageDetails.ts?vue&type=script&lang=ts&"
export * from "./packageDetails.ts?vue&type=script&lang=ts&"
import style0 from "./packageDetails.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports